import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/upload.tsx
var Upload = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M20 12.75V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V12.75M12 4.00003V15.25M12 4.00003L16.5 8.50003M12 4.00003L7.5 8.50003",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3.25C12.1989 3.25 12.3897 3.32902 12.5303 3.46967L17.0303 7.96967C17.3232 8.26256 17.3232 8.73744 17.0303 9.03033C16.7374 9.32322 16.2626 9.32322 15.9697 9.03033L12.75 5.81066V15.25C12.75 15.6642 12.4142 16 12 16C11.5858 16 11.25 15.6642 11.25 15.25V5.81066L8.03033 9.03033C7.73744 9.32322 7.26256 9.32322 6.96967 9.03033C6.67678 8.73744 6.67678 8.26256 6.96967 7.96967L11.4697 3.46967C11.6103 3.32902 11.8011 3.25 12 3.25ZM4 12C4.41421 12 4.75 12.3358 4.75 12.75V18C4.75 18.6904 5.30964 19.25 6 19.25H18C18.6904 19.25 19.25 18.6904 19.25 18V12.75C19.25 12.3358 19.5858 12 20 12C20.4142 12 20.75 12.3358 20.75 12.75V18C20.75 19.5188 19.5188 20.75 18 20.75H6C4.48122 20.75 3.25 19.5188 3.25 18V12.75C3.25 12.3358 3.58579 12 4 12Z",
		fill: "currentColor"
	})
});
//#endregion
export { Upload };
